<div class="modal-body text-center">
    <p id="company-confirm-remove-modal-title-text" style="font-size: 16px;"><strong>Confirm Delete</strong></p>
    <button id="company-confirm-remove-modal-cancel-button" type="button" class="btn btn-secondary mt-1" (click)="cancel()">CANCEL</button>
    <button id="company-confirm-remove-modal-confirm-button" type="button" class="btn btn-primary ml-2 mt-1" (click)="confirm()">CONFIRM</button>
</div>
